// checkout script extends category script
import "./base";
import address from "./app/store/modules/AddressModule";
ceresStore.registerModule("address", address);
import eventPropagation from "./app/store/plugins/EventPropagationPlugin";
eventPropagation(ceresStore);

import PickUpOptIn from "./app/components/checkout/PickUpOptIn.vue";
Vue.component("pick-up-opt-in", PickUpOptIn);
import CheckAge from "./app/components/checkout/CheckAge.vue";
Vue.component("check-age", CheckAge);
Vue.component("popper", () => import("./app/components/pageDesign/Popper.vue"));
Vue.component("login-view", () => import("./app/components/customer/login/LoginView.vue"));
import Registration from "./app/components/customer/Registration.vue";
Vue.component("registration", Registration);
import Login from "./app/components/customer/login/Login.vue";
Vue.component("login", Login);

Vue.component("forgot-password-modal", () => import("./app/components/customer/login/ForgotPassword.vue"));
import ResetPasswordForm from "./app/components/customer/ResetPasswordForm.vue";
Vue.component("reset-password-form", ResetPasswordForm);

// checkout
import "./app/components/checkout/Checkout";
import "./app/components/checkout/AcceptGtcCheck";
import "./app/components/checkout/ContactWishInput";
import "./app/components/checkout/PaymentProviderSelect";
import "./app/components/checkout/PlaceOrder";
import ShippingPrivacyHintCheck from "./app/components/checkout/ShippingPrivacyHintCheck.vue";
Vue.component("shipping-privacy-hint-check", ShippingPrivacyHintCheck);
import "./app/components/checkout/ShippingProfileSelect";
import ShippingNotice from "./app/components/checkout/ShippingNotice.vue";
Vue.component("shipping-notice", ShippingNotice);

// myAccount
import "./app/components/myAccount/AccountSettings";
import "./app/components/myAccount/BankDataSelect";
import "./app/components/myAccount/ChangePaymentMethod";
import "./app/components/myAccount/History";
import "./app/components/myAccount/MyAccount";

// costumer
import "./app/components/customer/AddressSelect/AddressHeader";

import AddressInputGroup from "./app/components/customer/AddressInputGroup.vue";
Vue.component("address-input-group", AddressInputGroup);
import ChangeEmailForm from "./app/components/customer/ChangeEmailForm.vue";
Vue.component("change-email-form", ChangeEmailForm);
// needed for checkout only
import GuestLogin from "./app/components/customer/login/GuestLogin.vue";
Vue.component("guest-login", GuestLogin);
import InvoiceAddressSelect from "./app/components/customer/AddressSelect/InvoiceAddressSelect.vue";
Vue.component("invoice-address-select", InvoiceAddressSelect);
import ShippingAddressSelect from "./app/components/customer/AddressSelect/ShippingAddressSelect.vue";
Vue.component("shipping-address-select", ShippingAddressSelect);
